// =============================================================================
// Inline notices — the app's own voice for "that failed" and "that worked".
//
// Why this exists: Books was calling window.alert(). The app had already ruled
// that out, in member-detail.js:
//
//   "A browser alert is the one piece of UI the app cannot style: it arrives in
//    the operating system's typeface with its own buttons in its own order, and
//    on a phone it lands over the middle of the screen covering the very book
//    being returned."
//
// Five screens had already grown their own five-line flash(). Those still work
// and are deliberately left alone — rewriting working code across five screens
// is churn with a regression in it. New code uses this; the others can migrate
// when they are next touched for another reason.
// =============================================================================

import { el } from './dom.js';

const DEFAULT_MS = 5000;

/**
 * Show a message inside `anchor`, and take it away again.
 *
 * `role="alert"` so a screen reader announces it: a message that only exists
 * for five seconds is no use to someone who cannot see it appear.
 */
export function flashNotice(anchor, message, { kind = 'error', ms = DEFAULT_MS } = {}) {
  if (!anchor || !message) return null;

  // One at a time per anchor. Two stacked failures push the content down and
  // read as one long broken message.
  anchor.querySelector(':scope > .flash-notice')?.remove();

  const note = el('p', {
    class: `flash-notice ${kind === 'error' ? 'error' : 'notice'}`,
    role: 'alert',
  }, message);

  anchor.prepend(note);
  if (ms > 0) setTimeout(() => note.remove(), ms);
  return note;
}

/** "Saved." — the confirmation a silent success never gave. */
export function flashSaved(anchor, message, ms = 2500) {
  return flashNotice(anchor, message, { kind: 'ok', ms });
}
